import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Card, IOption } from '@ss/meta-core-components'
import { GlobalStats } from './GlobalStats'
import { TimeSeriesComparison } from './TimeSeriesComparison'
import {
  ComparisonResponse,
  GlobalData,
  IGenericObject,
  LayersData,
} from '@types'
import { config } from '../../config'
import useRest from '../../hooks/useRest'
import { generateQuery } from '@utils'
import { Filters } from './Filters'

/**
 * Pagina Start up comparison
 * @component
 */
export const StartUpComparison: React.FC = () => {
  const [filters, setFilters] = useState<IGenericObject<IOption | null>>({})
  const [globalData, setGlobalData] = useState<GlobalData>()
  const [layerData, setLayerData] = useState<LayersData>()

  const { post: getTableData } = useRest<ComparisonResponse>('/comparison')

  //condizione per l'invio delle richieste
  const correctFilters = (): boolean => {
    if (!filters.anno || filters.anno.value === '') return false
    if (!filters.field || filters.field.value === '') return false
    if (!filters.aggregation || filters.aggregation.value === '') return false
    return true
  }

  //factory per il body delle richieste
  const generateRequestBody = (startUp?: '0' | '1') => ({
    index: config.dataSet.comparisonIndex,
    field: filters.field?.value,
    aggregation: filters.aggregation?.value,
    query_data: generateQuery({
      params: {
        anno: {
          value: `${filters.anno?.value}` || '',
          method: 'normal',
        },
        flag_startup: {
          value: startUp || '',
          method: 'normal',
        },
      },
    }),
  })

  //effect con la richiesta per i dati global e layers
  useEffect(() => {
    setGlobalData(undefined)
    setLayerData(undefined)
    if (!correctFilters()) return
    getTableData(generateRequestBody()).then(({ data: { global, layers } }) => {
      const newGlobal = { ...global }
      delete newGlobal?.startup.flag_startup
      delete newGlobal?.impresa.flag_startup
      setGlobalData({
        ...newGlobal,
      })
      setLayerData(layers)
    })
  }, [filters])

  return (
    <Container>
      <Filters setFilters={setFilters} />
      {correctFilters() ? (
        <>
          <GlobalStats
            selectedAggregation={(filters.aggregation?.value || '') as string}
            global={globalData}
            layers={layerData}
            field={filters.field}
          />
          <TimeSeriesComparison
            filters={filters}
            searchField={filters.field?.value || undefined}
          />
        </>
      ) : (
        <Card width={'100%'} position={'start'}>
          <Warning data-cy={'comparison-error'}>
            Per avviare l'analisi, selezionare un Anno , un Attributo e un
            Aggregazione dai selettori specifici.
          </Warning>
        </Card>
      )}
    </Container>
  )
}

//region style
const Container = styled.div`
  width: 100%;
  padding: 46px 30px 30px 30px;
  display: grid;
  grid-template-rows: 60px 550px max-content;
  gap: 20px;
`
const Warning = styled.div`
  width: 100%;
  max-height: 600px;
  text-align: center;
  height: 50px;
  padding: 15px;
`
//endregion
